var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('h4',{staticClass:"success-text"},[_vm._v(_vm._s(_vm.$t('pages_wechat_configs_success_1177')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }